import React from 'react';

export const CircleShareIcon = (props) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.882812" width="24" height="24" rx="12" fill="#2F80ED" />
      <path
        d="M7.74984 14.2174C8.48622 14.2174 9.08317 13.6205 9.08317 12.8841C9.08317 12.1477 8.48622 11.5508 7.74984 11.5508C7.01346 11.5508 6.4165 12.1477 6.4165 12.8841C6.4165 13.6205 7.01346 14.2174 7.74984 14.2174Z"
        stroke="white"
        strokeWidth="1.4"
      />
      <path
        d="M15.0831 9.54948C15.8195 9.54948 16.4164 8.95253 16.4164 8.21615C16.4164 7.47977 15.8195 6.88281 15.0831 6.88281C14.3467 6.88281 13.7498 7.47977 13.7498 8.21615C13.7498 8.95253 14.3467 9.54948 15.0831 9.54948Z"
        stroke="white"
        strokeWidth="1.4"
      />
      <path
        d="M8.83301 11.9456L13.732 9.11719"
        stroke="white"
        strokeWidth="1.4"
      />
      <path
        d="M15.0831 16.2161C15.8195 16.2161 16.4164 16.8131 16.4164 17.5495C16.4164 18.2859 15.8195 18.8828 15.0831 18.8828C14.3467 18.8828 13.7498 18.2859 13.7498 17.5495C13.7498 16.8131 14.3467 16.2161 15.0831 16.2161Z"
        stroke="white"
        strokeWidth="1.4"
      />
      <path
        d="M8.83301 13.9844L13.732 16.8128"
        stroke="white"
        strokeWidth="1.4"
      />
    </svg>
  );
};
